import React, { useState, useRef } from 'react';
import { MdClose, MdCheck, MdUndo, MdAssignment } from 'react-icons/md';
import { ItsmInput, CKEditorInput } from '../../../Plugin/component';
import { MentionsInput, Mention } from 'react-mentions';
import { defaultStyle, defaultMentionStyle } from './styles';
import { Typography } from "@material-ui/core";
import { NotificationManager } from "react-notifications";
import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import TextField from '@material-ui/core/TextField';
import Autocomplete from "@material-ui/lab/Autocomplete";
import './styles.scss';
import { AiOutlineClockCircle } from 'react-icons/ai';

export function ActionComponent(props) {
    const { status, type, data, feeds, checked, label, onChange, onClick, openDialog, backgroundColor, borderColor, isShow } = props;
    //gửi mail
    const refMailFrom = useRef();
    const refMailCC = useRef();
    const refMailSubject = useRef();
    //ticket new
    const refDetailOfChangeticket = useRef();
    const refExpectEndDateticket = useRef();
    const refAffectticket = useRef();
    const refCusQtyticket = useRef();
    const refPayTVQtyticket = useRef();
    const refLevelticket = useRef();
    const refTitleticket = useRef();
    const refDescriptionticket = useRef();
    const refAttachmentticket = useRef();
    const refQueueTypeIDticket = useRef();
    const refUserTypeIDticket = useRef();
    const refQueueTypeID1ticket = useRef();
    const refQueueTypeID2 = useRef();
    const refUserEmail2 = useRef();
    const refUserEmail1 = useRef();
    const refDescriptionKH = useRef();
    const refNameHM = useRef();
    const refToMail = useRef();
    const refCCMail = useRef();

    //ticket close
    const refIDTicket = useRef();
    const refDescription = useRef();
    const refUserEmail = useRef();
    const refData = useRef();

    // eslint-disable-next-line
    const [LoaiKH, setLoaiKH] = useState([
        { title: "Thông thường", value: 0 },
        { title: "Khẩn cấp", value: 1 }
    ])
    // eslint-disable-next-line
    const [LoaiHM, setLoaiHM] = useState([
        { title: "Thực hiện", value: 0 },
        { title: "Ảnh hưởng", value: 1 }
    ])
    // eslint-disable-next-line
    const [AnhHuongKH, seAnhHuongKH] = useState([
        { title: "Có", value: 0 },
        { title: "Không", value: 1 }
    ])
    // eslint-disable-next-line
    const [Level, setLevel] = useState([
        { title: "1", value: 1 },
        { title: "2", value: 2 },
        { title: "3", value: 3 },
        { title: "4", value: 4 },
        { title: "5", value: 5 },
        { title: "6", value: 6 }
    ])
    if (status === "INIT") {
        switch (type) {
            case "PLAN_CONFIRM":
            case "PLAN_CANCEL":
            case "PLAN_REJECT":
            case "PLAN_SAVE":
            case "MAIL":
            case "TICKET_NEW":
            case "TICKET_CLOSE":
            case "TICKET_REJECT":
            case "TICKET_CONFIRM":
            case "MAIL_CONFIRM":
            case "ADD_TIME_DEPLOY":
                return <>
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={checked}
                                onChange={(e) => {
                                    openDialog && openDialog();
                                    onChange && onChange(e, status)
                                }}
                                name="checkedB"
                                color="primary"
                            />
                        }
                        label={label}
                    />
                </>
            default:
                return <></>;
        }
    }
    else if (status === "USE") {
        switch (type) {
            case "PLAN_CONFIRM":
                return <Button style={{ margin: "0 2.5px", background: backgroundColor, borderColor: borderColor, color: 'white', width: "auto" }} variant="contained" className="btn-next" disabled={isShow} onClick={onClick} startIcon={<MdCheck />}>
                    {label}
                </Button>
            case "PLAN_CANCEL":
                return <Button style={{ margin: "0 2.5px", background: backgroundColor, borderColor: borderColor, color: 'white', width: "auto" }} onClick={onClick} disabled={isShow} variant="contained" className="btn-next" startIcon={<MdClose />}>
                    {label}
                </Button>
            case "PLAN_REJECT":
                return <Button style={{ margin: "0 2.5px", background: backgroundColor, borderColor: borderColor, color: 'white', width: "auto" }} onClick={onClick} disabled={isShow} variant="contained" className="btn-next" startIcon={<MdUndo />}>
                    {label}
                </Button>
            case "PLAN_SAVE":
                return <Button style={{ margin: "0 2.5px", background: backgroundColor, borderColor: borderColor, color: 'white', width: "auto" }} variant="contained" disabled={isShow} className="btn-next" onClick={onClick} startIcon={<MdAssignment />}>
                    {label}
                </Button>
            case "PLAN_AMPTY":
                return <Button style={{ margin: "0 2.5px", background: backgroundColor, borderColor: borderColor, color: 'white', width: "auto" }} variant="contained" disabled={isShow} className="btn-next" onClick={onClick} startIcon={<MdAssignment />}>
                    {label}
                </Button>
            case "ADD_TIME_DEPLOY":
                return <Button style={{ margin: "0 2.5px", background: backgroundColor, borderColor: borderColor, color: 'white', width: "auto" }} variant="contained" disabled={isShow} className="btn-next" onClick={onClick} startIcon={<AiOutlineClockCircle />}>
                    {label}
                </Button>
            case "MAIL":
                return <>
                    <span>Mail</span>
                    <div className="row"
                        style={{ border: "2px solid #9d8d8d", borderRadius: "10px", marginBottom: "3%" }} >
                        <div className="col-md-12">
                            <ItsmInput label="Gửi đến" className="action-config-input" ref={refMailFrom}>
                                <MentionsInput allowSpaceInQuery={true} singleLine={true} value={data && data.mailTo ? data.mailTo : ""}
                                    onFocus={() => refMailFrom.current.classList.add('itsm-input-focus')}
                                    onBlur={() => refMailFrom.current.classList.remove('itsm-input-focus')}
                                    onChange={(e) => onChange({ mailTo: e.target.value }, status)} style={defaultStyle} className="mentions-input">
                                    <Mention
                                        trigger="[["
                                        data={feeds.feedsDataDisplay}
                                        markup="[[__display__]]"
                                        style={defaultMentionStyle}
                                        renderSuggestion={(e) => <div className="custom-item">
                                            <div className="custom-item-username">
                                                {e.display.replace('[[', '').replace(']]', '')}
                                            </div>
                                        </div>}
                                    />
                                </MentionsInput>
                            </ItsmInput>
                        </div>
                        <div className="col-md-12">
                            <ItsmInput label="CC: " className="action-config-input" ref={refMailCC}>
                                <MentionsInput allowSpaceInQuery={true} singleLine={true} value={data && data.mailCC ? data.mailCC : ""}
                                    onFocus={() => refMailCC.current.classList.add('itsm-input-focus')}
                                    onBlur={() => refMailCC.current.classList.remove('itsm-input-focus')}
                                    onChange={(e) => onChange({ mailCC: e.target.value }, status)} style={defaultStyle} className="mentions-input">
                                    <Mention
                                        trigger="[["
                                        data={feeds.feedsDataDisplay}
                                        markup="[[__display__]]"
                                        style={defaultMentionStyle}
                                        renderSuggestion={(e) => <div className="custom-item">
                                            <div className="custom-item-username">
                                                {e.display.replace('[[', '').replace(']]', '')}
                                            </div>
                                        </div>}
                                    />
                                </MentionsInput>
                            </ItsmInput>
                        </div>
                        <div className="col-md-12"><ItsmInput label="Tiêu đề mail" className="action-config-input as" ref={refMailSubject}>
                            <MentionsInput allowSpaceInQuery={true} singleLine={true} value={data && data.mailSubject ? data.mailSubject : ""}
                                onFocus={() => refMailSubject.current.classList.add('itsm-input-focus')}
                                onBlur={() => refMailSubject.current.classList.remove('itsm-input-focus')}
                                onChange={(e) => onChange({ mailSubject: e.target.value }, status)} style={defaultStyle}>
                                <Mention
                                    trigger="[["
                                    data={feeds.feedsDataDisplay}
                                    markup="[[__display__]]"
                                    style={defaultMentionStyle}
                                    renderSuggestion={(e) => <div className="custom-item">
                                        <div className="custom-item-username">
                                            {e.display.replace('[[', '').replace(']]', '')}
                                        </div>
                                    </div>}
                                />
                            </MentionsInput>
                        </ItsmInput>
                        </div>
                        <div className="col-md-12">
                            <CKEditorInput feeds={feeds.feedsData} label="Nội dung mail" data={data && data.mailBody ? data.mailBody : ""}
                                onChange={(value) => onChange({ mailBody: value }, status)} />
                        </div>
                    </div>
                </>
            case "TICKET_NEW":
                return <>
                    <span style={{ marginTop: "1%" }} >Tạo Ticket</span>
                    <div className="row"
                        style={{ border: "2px solid #9d8d8d", borderRadius: "10px" }} >
                        <div className="col-md-6">
                            <Autocomplete
                                options={LoaiKH}
                                size="small"
                                getOptionLabel={(option) => option.title}
                                style={{ width: "100%" }}
                                renderInput={(params) => <TextField {...params} InputLabelProps={{
                                    shrink: true,
                                }}
                                    margin="dense"
                                    label="Loại kế hoạch *"
                                    variant="outlined"
                                    placeholder="Thông thường"
                                />}
                                renderOption={(option) => <Typography noWrap style={{ fontSize: "14px" }}>{option.title}</Typography>}
                                value={data && data.TypeOfChangeticket1 ? data.TypeOfChangeticket1 : ""}
                                onChange={(e, newValue) => {
                                    onChange({ TypeOfChangeticket1: newValue }, status)
                                }}
                            />

                            <ItsmInput label="Thời gian dự kiến bắt đầu *" className="action-config-input DetailOfChangeticket" ref={refDetailOfChangeticket}>
                                <MentionsInput allowSpaceInQuery={true} singleLine={true} value={data && data.DetailOfChangeticket ? data.DetailOfChangeticket : ""}
                                    onFocus={() => refDetailOfChangeticket.current.classList.add('itsm-input-focus')} onBlur={() => refDetailOfChangeticket.current.classList.remove('itsm-input-focus')}
                                    onChange={(e) => onChange({ DetailOfChangeticket: e.target.value }, status)} style={defaultStyle}>
                                    <Mention
                                        trigger="[["
                                        data={feeds.feedsDataDisplay}
                                        markup="[[__display__]]"
                                        style={defaultMentionStyle}
                                        renderSuggestion={(e) => <div className="custom-item">
                                            <div className="custom-item-username">
                                                {e.display.replace('[[', '').replace(']]', '')}
                                            </div>
                                        </div>}
                                    />
                                </MentionsInput>
                            </ItsmInput>

                            <Autocomplete
                                options={LoaiHM}
                                size="small"
                                getOptionLabel={(option) => option.title}
                                ref={refUserEmail1}
                                style={{ width: "100%" }}
                                renderInput={(params) => <TextField {...params} InputLabelProps={{
                                    shrink: true,
                                }}
                                    margin="dense"
                                    label="Loại hạng mục"
                                    variant="outlined"
                                    placeholder="Thực hiện" />}
                                renderOption={(option) => <Typography noWrap style={{ fontSize: "14px" }}>{option.title}</Typography>}
                                value={data && data.TypeHM ? data.TypeHM : ""}
                                onChange={(e, newValue) => onChange({ TypeHM: newValue }, status)}
                            />
                            <ItsmInput label="Tiêu đề kế hoạch *" className="action-config-input Titleticket" ref={refTitleticket}>
                                <MentionsInput allowSpaceInQuery={true} singleLine={true} value={data && data.Titleticket ? data.Titleticket : ""}
                                    onFocus={() => refTitleticket.current.classList.add('itsm-input-focus')} onBlur={() => refTitleticket.current.classList.remove('itsm-input-focus')}
                                    onChange={(e) => onChange({ Titleticket: e.target.value }, status)} style={defaultStyle} className="mentions-input">
                                    <Mention
                                        trigger="[["
                                        data={feeds.feedsDataDisplay}
                                        markup="[[__display__]]"
                                        style={defaultMentionStyle}
                                        renderSuggestion={(e) => <div className="custom-item">
                                            <div className="custom-item-username">
                                                {e.display.replace('[[', '').replace(']]', '')}
                                            </div>
                                        </div>}
                                    />
                                </MentionsInput>
                            </ItsmInput>
                            <Autocomplete
                                options={AnhHuongKH}
                                size="small"
                                getOptionLabel={(option) => option.title}
                                ref={refAffectticket}
                                style={{ width: "100%" }}
                                renderInput={(params) => <TextField {...params} InputLabelProps={{
                                    shrink: true,
                                }}
                                    margin="dense"
                                    label="Ảnh hưởng KHG *"
                                    variant="outlined"
                                    placeholder="Không" />}
                                renderOption={(option) => <Typography noWrap style={{ fontSize: "14px" }}>{option.title}</Typography>}
                                value={data && data.Affectticket ? data.Affectticket : ""}
                                onChange={(e, newValue) => onChange({ Affectticket: newValue }, status)}
                            />
                            <ItsmInput label="Số lượng KHG bị ảnh hưởng *" className="action-config-input CusQtyticket" ref={refCusQtyticket}>
                                <MentionsInput allowSpaceInQuery={true} singleLine={true} value={data && data.CusQtyticket ? data.CusQtyticket : ""}
                                    onFocus={() => refCusQtyticket.current.classList.add('itsm-input-focus')} onBlur={() => refCusQtyticket.current.classList.remove('itsm-input-focus')}
                                    onChange={(e) => onChange({ CusQtyticket: e.target.value }, status)} style={defaultStyle}
                                    placeholder="0"
                                >

                                    <Mention
                                        trigger="[["
                                        data={feeds.feedsDataDisplay}
                                        markup="[[__display__]]"
                                        style={defaultMentionStyle}
                                        renderSuggestion={(e) => <div className="custom-item">
                                            <div className="custom-item-username">
                                                {e.display.replace('[[', '').replace(']]', '')}
                                            </div>
                                        </div>}
                                    />
                                </MentionsInput>
                            </ItsmInput>
                            <ItsmInput label="Số lượng KHG PayTV bị ảnh hưởng *" className="action-config-input PayTVQtyticket" ref={refPayTVQtyticket}>
                                <MentionsInput allowSpaceInQuery={true} singleLine={true} value={data && data.PayTVQtyticket ? data.PayTVQtyticket : ""}
                                    onFocus={() => refPayTVQtyticket.current.classList.add('itsm-input-focus')} onBlur={() => refPayTVQtyticket.current.classList.remove('itsm-input-focus')}
                                    onChange={(e) => onChange({ PayTVQtyticket: e.target.value }, status)} style={defaultStyle} className="mentions-input"
                                    placeholder="0"
                                >
                                    <Mention
                                        trigger="[["
                                        data={feeds.feedsDataDisplay}
                                        markup="[[__display__]]"
                                        style={defaultMentionStyle}
                                        renderSuggestion={(e) => <div className="custom-item">
                                            <div className="custom-item-username">
                                                {e.display.replace('[[', '').replace(']]', '')}
                                            </div>
                                        </div>}
                                    />
                                </MentionsInput>
                            </ItsmInput>
                            <Autocomplete
                                options={Level}
                                size="small"
                                getOptionLabel={(option) => option.title}
                                ref={refLevelticket}
                                style={{ width: "100%" }}
                                renderInput={(params) => <TextField {...params} InputLabelProps={{
                                    shrink: true,
                                }}
                                    margin="dense"
                                    label="Cấp độ kế hoạch *"
                                    variant="outlined" placeholder='2' />}
                                renderOption={(option) => <Typography noWrap style={{ fontSize: "14px" }}>{option.title}</Typography>}
                                value={data && data.Levelticket ? data.Levelticket : ""}
                                onChange={(e, newValue) => onChange({ Levelticket: newValue }, status)}
                            />
                            <ItsmInput label="Ghi chú" className="action-config-input Descriptionticket" ref={refDescriptionticket}>
                                <MentionsInput allowSpaceInQuery={true} singleLine={true} value={data && data.Descriptionticket ? data.Descriptionticket : ""}
                                    onFocus={() => refDescriptionticket.current.classList.add('itsm-input-focus')} onBlur={() => refDescriptionticket.current.classList.remove('itsm-input-focus')}
                                    onChange={(e) => onChange({ Descriptionticket: e.target.value }, status)} style={defaultStyle} className="mentions-input">
                                    <Mention
                                        trigger="[["
                                        data={feeds.feedsDataDisplay}
                                        markup="[[__display__]]"
                                        style={defaultMentionStyle}
                                        renderSuggestion={(e) => <div className="custom-item">
                                            <div className="custom-item-username">
                                                {e.display.replace('[[', '').replace(']]', '')}
                                            </div>
                                        </div>}
                                    />
                                </MentionsInput>
                            </ItsmInput>
                            <ItsmInput label="To Mail" className="action-config-input ToMail" ref={refToMail}>
                                <MentionsInput allowSpaceInQuery={true} singleLine={true} value={data && data.ToMail ? data.ToMail : ""}
                                    onFocus={() => refToMail.current.classList.add('itsm-input-focus')} onBlur={() => refToMail.current.classList.remove('itsm-input-focus')}
                                    onChange={(e) => onChange({ ToMail: e.target.value }, status)} style={defaultStyle}

                                >

                                    <Mention
                                        trigger="[["
                                        data={feeds.feedsDataDisplay}
                                        markup="[[__display__]]"
                                        style={defaultMentionStyle}
                                        renderSuggestion={(e) => <div className="custom-item">
                                            <div className="custom-item-username">
                                                {e.display.replace('[[', '').replace(']]', '')}
                                            </div>
                                        </div>}
                                    />
                                </MentionsInput>
                            </ItsmInput>
                            <ItsmInput label="CC Mail" className="action-config-input CCMail" ref={refCCMail}>
                                <MentionsInput allowSpaceInQuery={true} singleLine={true} value={data && data.CCMail ? data.CCMail : ""}
                                    onFocus={() => refCCMail.current.classList.add('itsm-input-focus')} onBlur={() => refCCMail.current.classList.remove('itsm-input-focus')}
                                    onChange={(e) => onChange({ CCMail: e.target.value }, status)} style={defaultStyle}

                                >

                                    <Mention
                                        trigger="[["
                                        data={feeds.feedsDataDisplay}
                                        markup="[[__display__]]"
                                        style={defaultMentionStyle}
                                        renderSuggestion={(e) => <div className="custom-item">
                                            <div className="custom-item-username">
                                                {e.display.replace('[[', '').replace(']]', '')}
                                            </div>
                                        </div>}
                                    />
                                </MentionsInput>
                            </ItsmInput>
                        </div>
                        <div className="col-md-6">
                            <ItsmInput label="Mô tả kế hoạch" className="action-config-input CusTypeticket" ref={refDescriptionKH}>
                                <MentionsInput allowSpaceInQuery={true} singleLine={true} value={data && data.DescriptionKH ? data.DescriptionKH : ""}
                                    onFocus={() => refDescriptionKH.current.classList.add('itsm-input-focus')} onBlur={() => refDescriptionKH.current.classList.remove('itsm-input-focus')}
                                    onChange={(e) => onChange({ DescriptionKH: e.target.value }, status)} style={defaultStyle}>
                                    <Mention
                                        trigger="[["
                                        data={feeds.feedsDataDisplay}
                                        markup="[[__display__]]"
                                        style={defaultMentionStyle}
                                        renderSuggestion={(e) => <div className="custom-item">
                                            <div className="custom-item-username">
                                                {e.display.replace('[[', '').replace(']]', '')}
                                            </div>
                                        </div>}
                                    />
                                </MentionsInput>
                            </ItsmInput>
                            <ItsmInput label="Thời gian dự kiến hoàn tất *" className="action-config-input ExpectEndDateticket" ref={refExpectEndDateticket}>
                                <MentionsInput allowSpaceInQuery={true} singleLine={true} value={data && data.ExpectEndDateticket ? data.ExpectEndDateticket : ""}
                                    onFocus={() => refExpectEndDateticket.current.classList.add('itsm-input-focus')} onBlur={() => refExpectEndDateticket.current.classList.remove('itsm-input-focus')}
                                    onChange={(e) => onChange({ ExpectEndDateticket: e.target.value }, status)} style={defaultStyle} className="mentions-input">
                                    <Mention
                                        trigger="[["
                                        data={feeds.feedsDataDisplay}
                                        markup="[[__display__]]"
                                        style={defaultMentionStyle}
                                        renderSuggestion={(e) => <div className="custom-item">
                                            <div className="custom-item-username">
                                                {e.display.replace('[[', '').replace(']]', '')}
                                            </div>
                                        </div>}
                                    />
                                </MentionsInput>
                            </ItsmInput>
                            <ItsmInput label="Tên hạn mục" className="action-config-input CusTypeticket" ref={refNameHM}>
                                <MentionsInput allowSpaceInQuery={true} singleLine={true} value={data && data.NameHM ? data.NameHM : ""}
                                    onFocus={() => refNameHM.current.classList.add('itsm-input-focus')} onBlur={() => refNameHM.current.classList.remove('itsm-input-focus')}
                                    onChange={(e) => onChange({ NameHM: e.target.value }, status)} style={defaultStyle}>
                                    <Mention
                                        trigger="[["
                                        data={feeds.feedsDataDisplay}
                                        markup="[[__display__]]"
                                        style={defaultMentionStyle}
                                        renderSuggestion={(e) => <div className="custom-item">
                                            <div className="custom-item-username">
                                                {e.display.replace('[[', '').replace(']]', '')}
                                            </div>
                                        </div>}
                                    />
                                </MentionsInput>
                            </ItsmInput>

                            <ItsmInput label="Đơn vị tạo *" className="action-config-input QueueTypeIDticket" ref={refQueueTypeIDticket}>
                                <MentionsInput allowSpaceInQuery={true} singleLine={true} value={data && data.QueueTypeIDticket ? data.QueueTypeIDticket : ""}
                                    onFocus={() => refQueueTypeIDticket.current.classList.add('itsm-input-focus')} onBlur={() => refQueueTypeIDticket.current.classList.remove('itsm-input-focus')}
                                    onChange={(e) => onChange({ QueueTypeIDticket: e.target.value }, status)} style={defaultStyle} className="mentions-input"
                                    placeholder="ISC"
                                >
                                    <Mention
                                        trigger="[["
                                        data={feeds.feedsDataDisplay}
                                        markup="[[__display__]]"
                                        style={defaultMentionStyle}
                                        renderSuggestion={(e) => <div className="custom-item">
                                            <div className="custom-item-username">
                                                {e.display.replace('[[', '').replace(']]', '')}
                                            </div>
                                        </div>}
                                    />
                                </MentionsInput>
                            </ItsmInput>
                            <ItsmInput label="Nhân sự tạo *" className="action-config-input UserTypeIDticket" ref={refUserTypeIDticket}>
                                <MentionsInput allowSpaceInQuery={true} singleLine={true} value={data && data.UserTypeIDticket ? data.UserTypeIDticket : ""}
                                    onFocus={() => refUserTypeIDticket.current.classList.add('itsm-input-focus')} onBlur={() => refUserTypeIDticket.current.classList.remove('itsm-input-focus')}
                                    onChange={(e) => onChange({ UserTypeIDticket: e.target.value }, status)} style={defaultStyle}>
                                    <Mention
                                        trigger="[["
                                        data={feeds.feedsDataDisplay}
                                        markup="[[__display__]]"
                                        style={defaultMentionStyle}
                                        renderSuggestion={(e) => <div className="custom-item">
                                            <div className="custom-item-username">
                                                {e.display.replace('[[', '').replace(']]', '')}
                                            </div>
                                        </div>}
                                    />
                                </MentionsInput>
                            </ItsmInput>
                            <ItsmInput label="Đơn vị phê duyệt *" className="action-config-input QueueTypeID1ticket" ref={refQueueTypeID1ticket}>
                                <MentionsInput allowSpaceInQuery={true} singleLine={true} value={data && data.QueueTypeID1ticket ? data.QueueTypeID1ticket : ""}
                                    onFocus={() => refQueueTypeID1ticket.current.classList.add('itsm-input-focus')} onBlur={() => refQueueTypeID1ticket.current.classList.remove('itsm-input-focus')}
                                    onChange={(e) => onChange({ QueueTypeID1ticket: e.target.value }, status)} style={defaultStyle}
                                    placeholder="ISC"
                                >
                                    <Mention
                                        trigger="[["
                                        data={feeds.feedsDataDisplay}
                                        markup="[[__display__]]"
                                        style={defaultMentionStyle}
                                        renderSuggestion={(e) => <div className="custom-item">
                                            <div className="custom-item-username">
                                                {e.display.replace('[[', '').replace(']]', '')}
                                            </div>
                                        </div>}
                                    />
                                </MentionsInput>
                            </ItsmInput>
                            <ItsmInput label="Email phê duyệt *" className="action-config-input QueueTypeID2" ref={refUserEmail1}>
                                <MentionsInput allowSpaceInQuery={true} singleLine={true} value={data && data.UserEmail1 ? data.UserEmail1 : ""}
                                    onFocus={() => refUserEmail1.current.classList.add('itsm-input-focus')} onBlur={() => refUserEmail1.current.classList.remove('itsm-input-focus')}
                                    onChange={(e) => onChange({ UserEmail1: e.target.value }, status)} style={defaultStyle} className="mentions-input">
                                    <Mention
                                        trigger="[["
                                        data={feeds.feedsDataDisplay}
                                        markup="[[__display__]]"
                                        style={defaultMentionStyle}
                                        renderSuggestion={(e) => <div className="custom-item">
                                            <div className="custom-item-username">
                                                {e.display.replace('[[', '').replace(']]', '')}
                                            </div>
                                        </div>}
                                    />
                                </MentionsInput>
                            </ItsmInput>

                            <ItsmInput label="Đơn vị thực hiện *" className="action-config-input QueueTypeID2" ref={refQueueTypeID2}>
                                <MentionsInput allowSpaceInQuery={true} singleLine={true} value={data && data.QueueTypeID2 ? data.QueueTypeID2 : ""}
                                    onFocus={() => refQueueTypeID2.current.classList.add('itsm-input-focus')} onBlur={() => refQueueTypeID2.current.classList.remove('itsm-input-focus')}
                                    onChange={(e) => onChange({ QueueTypeID2: e.target.value }, status)} style={defaultStyle} className="mentions-input"
                                    placeholder="ISC"
                                >
                                    <Mention
                                        trigger="[["
                                        data={feeds.feedsDataDisplay}
                                        markup="[[__display__]]"
                                        style={defaultMentionStyle}
                                        renderSuggestion={(e) => <div className="custom-item">
                                            <div className="custom-item-username">
                                                {e.display.replace('[[', '').replace(']]', '')}
                                            </div>
                                        </div>}
                                    />
                                </MentionsInput>
                            </ItsmInput>
                            <ItsmInput label="Nhân sự thực hiện *" className="action-config-input UserEmail2" ref={refUserEmail2}>
                                <MentionsInput allowSpaceInQuery={true} singleLine={true} value={data && data.UserEmail2 ? data.UserEmail2 : ""}
                                    onFocus={() => refUserEmail2.current.classList.add('itsm-input-focus')} onBlur={() => refUserEmail2.current.classList.remove('itsm-input-focus')}
                                    onChange={(e) => onChange({ UserEmail2: e.target.value }, status)} style={defaultStyle} className="mentions-input">
                                    <Mention
                                        trigger="[["
                                        data={feeds.feedsDataDisplay}
                                        markup="[[__display__]]"
                                        style={defaultMentionStyle}
                                        renderSuggestion={(e) => <div className="custom-item">
                                            <div className="custom-item-username">
                                                {e.display.replace('[[', '').replace(']]', '')}
                                            </div>
                                        </div>}
                                    />
                                </MentionsInput>
                            </ItsmInput>
                            <ItsmInput label="Đính kèm" className="action-config-input Attachmentticket" ref={refAttachmentticket}>
                                <MentionsInput allowSpaceInQuery={true} singleLine={true} value={data && data.Attachmentticket ? data.Attachmentticket : ""}
                                    onFocus={() => refAttachmentticket.current.classList.add('itsm-input-focus')} onBlur={() => refAttachmentticket.current.classList.remove('itsm-input-focus')}
                                    onChange={(e) => onChange({ Attachmentticket: e.target.value }, status)} style={defaultStyle}>
                                    <Mention
                                        trigger="[["
                                        data={feeds.feedsDataDisplay}
                                        markup="[[__display__]]"
                                        style={defaultMentionStyle}
                                        renderSuggestion={(e) => <div className="custom-item">
                                            <div className="custom-item-username">
                                                {e.display.replace('[[', '').replace(']]', '')}
                                            </div>
                                        </div>}
                                    />
                                </MentionsInput>
                            </ItsmInput>
                        </div>
                    </div>
                </>
            case "TICKET_CLOSE":
                return <>
                    <span style={{ marginTop: "1%" }}>Đóng Ticket</span>
                    <div className="row" style={{ border: "2px solid #9d8d8d", borderRadius: "10px" }} >
                        <div className='col-md-6'>
                            <ItsmInput label="Mã ID Ticket *" className="action-config-input IDTicket" ref={refIDTicket}>
                                <MentionsInput allowSpaceInQuery={true} singleLine={true} value={data && data.IDTicket ? data.IDTicket : ""}
                                    onFocus={() => refIDTicket.current.classList.add('itsm-input-focus')} onBlur={() => refIDTicket.current.classList.remove('itsm-input-focus')}
                                    onChange={(e) => onChange({ IDTicket: e.target.value }, status)} style={defaultStyle}>
                                    <Mention
                                        trigger="[["
                                        data={feeds.feedsDataDisplay}
                                        markup="[[__display__]]"
                                        style={defaultMentionStyle}
                                        renderSuggestion={(e) => <div className="custom-item">
                                            <div className="custom-item-username">
                                                {e.display.replace('[[', '').replace(']]', '')}
                                            </div>
                                        </div>}
                                    />
                                </MentionsInput>
                            </ItsmInput>
                            <ItsmInput label="Description" className="action-config-input Description" ref={refDescription}>
                                <MentionsInput allowSpaceInQuery={true} singleLine={true} value={data && data.Description ? data.Description : ""}
                                    onFocus={() => refDescription.current.classList.add('itsm-input-focus')} onBlur={() => refDescription.current.classList.remove('itsm-input-focus')}
                                    onChange={(e) => onChange({ Description: e.target.value }, status)} style={defaultStyle}>
                                    <Mention
                                        trigger="[["
                                        data={feeds.feedsDataDisplay}
                                        markup="[[__display__]]"
                                        style={defaultMentionStyle}
                                        renderSuggestion={(e) => <div className="custom-item">
                                            <div className="custom-item-username">
                                                {e.display.replace('[[', '').replace(']]', '')}
                                            </div>
                                        </div>}
                                    />
                                </MentionsInput>
                            </ItsmInput>
                        </div>
                        <div className='col-md-6'>
                            <ItsmInput label="Email người đóng *" className="action-config-input ActionID" ref={refUserEmail}>
                                <MentionsInput allowSpaceInQuery={true} singleLine={true} value={data && data.UserEmail ? data.UserEmail : ""}
                                    onFocus={() => refUserEmail.current.classList.add('itsm-input-focus')} onBlur={() => refUserEmail.current.classList.remove('itsm-input-focus')}
                                    onChange={(e) => onChange({ UserEmail: e.target.value }, status)} style={defaultStyle}>
                                    <Mention
                                        trigger="[["
                                        data={feeds.feedsDataDisplay}
                                        markup="[[__display__]]"
                                        style={defaultMentionStyle}
                                        renderSuggestion={(e) => <div className="custom-item">
                                            <div className="custom-item-username">
                                                {e.display.replace('[[', '').replace(']]', '')}
                                            </div>
                                        </div>}
                                    />
                                </MentionsInput>
                            </ItsmInput>
                            <ItsmInput label="Data" className="action-config-input Data" ref={refData}>
                                <MentionsInput allowSpaceInQuery={true} singleLine={true} value={data && data.Data ? data.Data : ""}
                                    onFocus={() => refData.current.classList.add('itsm-input-focus')} onBlur={() => refData.current.classList.remove('itsm-input-focus')}
                                    onChange={(e) => onChange({ Data: e.target.value }, status)} style={defaultStyle}>
                                    <Mention
                                        trigger="[["
                                        data={feeds.feedsDataDisplay}
                                        markup="[[__display__]]"
                                        style={defaultMentionStyle}
                                        renderSuggestion={(e) => <div className="custom-item">
                                            <div className="custom-item-username">
                                                {e.display.replace('[[', '').replace(']]', '')}
                                            </div>
                                        </div>}
                                    />
                                </MentionsInput>
                            </ItsmInput>
                        </div>
                    </div>
                </>
            case "TICKET_CONFIRM":
                return <>
                    <span style={{ marginTop: "1%" }}>Duyệt ticket</span>
                    <div className="row" style={{ border: "2px solid #9d8d8d", borderRadius: "10px" }} >
                        <div className='col-md-6'>
                            <ItsmInput label="Mã ID Ticket *" className="action-config-input IDTicket" ref={refIDTicket}>
                                <MentionsInput allowSpaceInQuery={true} singleLine={true} value={data && data.IDTicket ? data.IDTicket : ""}
                                    onFocus={() => refIDTicket.current.classList.add('itsm-input-focus')} onBlur={() => refIDTicket.current.classList.remove('itsm-input-focus')}
                                    onChange={(e) => onChange({ IDTicket: e.target.value }, status)} style={defaultStyle}>
                                    <Mention
                                        trigger="[["
                                        data={feeds.feedsDataDisplay}
                                        markup="[[__display__]]"
                                        style={defaultMentionStyle}
                                        renderSuggestion={(e) => <div className="custom-item">
                                            <div className="custom-item-username">
                                                {e.display.replace('[[', '').replace(']]', '')}
                                            </div>
                                        </div>}
                                    />
                                </MentionsInput>
                            </ItsmInput>
                            <ItsmInput label="Description" className="action-config-input Description" ref={refDescription}>
                                <MentionsInput allowSpaceInQuery={true} singleLine={true} value={data && data.Description ? data.Description : ""}
                                    onFocus={() => refDescription.current.classList.add('itsm-input-focus')} onBlur={() => refDescription.current.classList.remove('itsm-input-focus')}
                                    onChange={(e) => onChange({ Description: e.target.value }, status)} style={defaultStyle}>
                                    <Mention
                                        trigger="[["
                                        data={feeds.feedsDataDisplay}
                                        markup="[[__display__]]"
                                        style={defaultMentionStyle}
                                        renderSuggestion={(e) => <div className="custom-item">
                                            <div className="custom-item-username">
                                                {e.display.replace('[[', '').replace(']]', '')}
                                            </div>
                                        </div>}
                                    />
                                </MentionsInput>
                            </ItsmInput>
                        </div>
                        <div className='col-md-6'>
                            <ItsmInput label="Email người duyệt *" className="action-config-input ActionID" ref={refUserEmail}>
                                <MentionsInput allowSpaceInQuery={true} singleLine={true} value={data && data.UserEmail ? data.UserEmail : ""}
                                    onFocus={() => refUserEmail.current.classList.add('itsm-input-focus')} onBlur={() => refUserEmail.current.classList.remove('itsm-input-focus')}
                                    onChange={(e) => onChange({ UserEmail: e.target.value }, status)} style={defaultStyle}>
                                    <Mention
                                        trigger="[["
                                        data={feeds.feedsDataDisplay}
                                        markup="[[__display__]]"
                                        style={defaultMentionStyle}
                                        renderSuggestion={(e) => <div className="custom-item">
                                            <div className="custom-item-username">
                                                {e.display.replace('[[', '').replace(']]', '')}
                                            </div>
                                        </div>}
                                    />
                                </MentionsInput>
                            </ItsmInput>
                            <ItsmInput label="Data" className="action-config-input Data" ref={refData}>
                                <MentionsInput allowSpaceInQuery={true} singleLine={true} value={data && data.Data ? data.Data : ""}
                                    onFocus={() => refData.current.classList.add('itsm-input-focus')} onBlur={() => refData.current.classList.remove('itsm-input-focus')}
                                    onChange={(e) => onChange({ Data: e.target.value }, status)} style={defaultStyle}>
                                    <Mention
                                        trigger="[["
                                        data={feeds.feedsDataDisplay}
                                        markup="[[__display__]]"
                                        style={defaultMentionStyle}
                                        renderSuggestion={(e) => <div className="custom-item">
                                            <div className="custom-item-username">
                                                {e.display.replace('[[', '').replace(']]', '')}
                                            </div>
                                        </div>}
                                    />
                                </MentionsInput>
                            </ItsmInput>
                        </div>
                    </div>
                </>
            case "MAIL_CONFIRM":
                return <>
                    <span>Mail Confirm</span>
                    <div className="row"
                        style={{ border: "2px solid #9d8d8d", borderRadius: "10px", marginBottom: "3%" }} >
                        <div className="col-md-12">
                            <ItsmInput label="Gửi đến" className="action-config-input" ref={refMailFrom}>
                                <MentionsInput allowSpaceInQuery={true} singleLine={true} value={data && data.mailTo ? data.mailTo : ""}
                                    onFocus={() => refMailFrom.current.classList.add('itsm-input-focus')}
                                    onBlur={() => refMailFrom.current.classList.remove('itsm-input-focus')}
                                    onChange={(e) => onChange({ mailTo: e.target.value }, status)} style={defaultStyle} className="mentions-input">
                                    <Mention
                                        trigger="[["
                                        data={feeds.feedsDataDisplay}
                                        markup="[[__display__]]"
                                        style={defaultMentionStyle}
                                        renderSuggestion={(e) => <div className="custom-item">
                                            <div className="custom-item-username">
                                                {e.display.replace('[[', '').replace(']]', '')}
                                            </div>
                                        </div>}
                                    />
                                </MentionsInput>
                            </ItsmInput>
                        </div>
                        <div className="col-md-12">
                            <ItsmInput label="CC: " className="action-config-input" ref={refMailCC}>
                                <MentionsInput allowSpaceInQuery={true} singleLine={true} value={data && data.mailCC ? data.mailCC : ""}
                                    onFocus={() => refMailCC.current.classList.add('itsm-input-focus')}
                                    onBlur={() => refMailCC.current.classList.remove('itsm-input-focus')}
                                    onChange={(e) => onChange({ mailCC: e.target.value }, status)} style={defaultStyle} className="mentions-input">
                                    <Mention
                                        trigger="[["
                                        data={feeds.feedsDataDisplay}
                                        markup="[[__display__]]"
                                        style={defaultMentionStyle}
                                        renderSuggestion={(e) => <div className="custom-item">
                                            <div className="custom-item-username">
                                                {e.display.replace('[[', '').replace(']]', '')}
                                            </div>
                                        </div>}
                                    />
                                </MentionsInput>
                            </ItsmInput>
                        </div>
                        <div className="col-md-12"><ItsmInput label="Tiêu đề mail" className="action-config-input as" ref={refMailSubject}>
                            <MentionsInput allowSpaceInQuery={true} singleLine={true} value={data && data.mailSubject ? data.mailSubject : ""}
                                onFocus={() => refMailSubject.current.classList.add('itsm-input-focus')}
                                onBlur={() => refMailSubject.current.classList.remove('itsm-input-focus')}
                                onChange={(e) => onChange({ mailSubject: e.target.value }, status)} style={defaultStyle}>
                                <Mention
                                    trigger="[["
                                    data={feeds.feedsDataDisplay}
                                    markup="[[__display__]]"
                                    style={defaultMentionStyle}
                                    renderSuggestion={(e) => <div className="custom-item">
                                        <div className="custom-item-username">
                                            {e.display.replace('[[', '').replace(']]', '')}
                                        </div>
                                    </div>}
                                />
                            </MentionsInput>
                        </ItsmInput>
                        </div>
                        <div className="col-md-12">
                            <CKEditorInput feeds={feeds.feedsData} label="Nội dung mail" data={data && data.mailBody ? data.mailBody : ""}
                                onChange={(value) => onChange({ mailBody: value }, status)} />
                        </div>
                    </div>
                </>
            default:
                return <></>;
        }
    }
}

export function ActionConfigComponent(props) {
    const { status, type, feeds, checked, onChange, label, propsJson } = props;
    const [open, setOpen] = useState(false);
    const [dependentActions, setDependentActions] = useState([]);
    const [rename, setRename] = useState();
    const [backgroundColor, setBackgroundColor] = useState();
    const [borderColor, setBorderColor] = useState();

    React.useEffect(() => {
        setDependentActions(props.dependentActions);
        setRename(propsJson && propsJson.rename ? propsJson.rename : "")
        setBackgroundColor(propsJson && propsJson.backgroundColor ? propsJson.backgroundColor : "#3fcbc8");
        setBorderColor(propsJson && propsJson.borderColor ? propsJson.borderColor : "#3fcbc8");
        // eslint-disable-next-line
    }, []);

    const IsJsonString = (str) => {
        try {
            JSON.parse(str);
        } catch (e) {
            return true;
        }
        return false;
    }
    React.useEffect(() => {
        setDependentActions(() => {
            let arraypropsJsonsetopen = [];
            if (props.dependentActions) {
                // eslint-disable-next-line
                props.dependentActions.map(item => {
                    arraypropsJsonsetopen.push({ ...item, propsJson: IsJsonString(item.propsJson) === true ? item.propsJson : JSON.parse(item.propsJson) })
                });
            }
            return arraypropsJsonsetopen;
        });
        setRename(propsJson && propsJson.rename ? propsJson.rename : "");
        setBackgroundColor(propsJson && propsJson.backgroundColor ? propsJson.backgroundColor : "#3fcbc8");
        setBorderColor(propsJson && propsJson.borderColor ? propsJson.borderColor : "#3fcbc8");
        // eslint-disable-next-line
    }, [open]);

    const handleClickOpen = () => {
        setOpen(true);
    };
    const handleClose = (Action, index) => {
        const propsJsonNew = dependentActions[1].propsJson
        if (dependentActions[1].checked === true && Action === "1") {
            if (propsJsonNew === null) {
                NotificationManager.error(`Vui lòng nhập thời gian dự kiến bắt đầu`);
                return;
            }
            else {
                if (propsJsonNew.DetailOfChangeticket === undefined || propsJsonNew.DetailOfChangeticket === null || propsJsonNew.DetailOfChangeticket === "") {
                    NotificationManager.error(`Vui lòng nhập thời gian dự kiến bắt đầu`);
                    return;
                }
                else if (propsJsonNew.Titleticket === "" || propsJsonNew.Titleticket === null || propsJsonNew.Titleticket === undefined) {
                    NotificationManager.error(`Vui lòng nhập tên tiêu đề kế hoạch *`);
                    return;
                }
                else if (propsJsonNew.ExpectEndDateticket === "" || propsJsonNew.ExpectEndDateticket === null || propsJsonNew.ExpectEndDateticket === undefined) {
                    NotificationManager.error(`Vui lòng nhập thời gian dự kiến hoàn tất *`);
                    return;
                }
                else if (propsJsonNew.UserTypeIDticket === "" || propsJsonNew.UserTypeIDticket === null || propsJsonNew.UserTypeIDticket === undefined) {
                    NotificationManager.error(`Vui lòng nhập tên nhân sự tạo *`);
                    return;
                }
                else if (propsJsonNew.UserEmail1 === "" || propsJsonNew.UserEmail1 === null || propsJsonNew.UserEmail1 === undefined) {
                    NotificationManager.error(`Vui lòng nhập tên email phê duyệt *`);
                    return;
                }
                else if (propsJsonNew.UserEmail2 === "" || propsJsonNew.UserEmail2 === null || propsJsonNew.UserEmail2 === undefined) {
                    NotificationManager.error(`Vui lòng nhập tên nhân sự thực hiện *`);
                    return;
                }
                else {
                    setOpen(false);
                    NotificationManager.success(`Kích hoạt thành công `);
                }
            }
        }
        else if (dependentActions[2].checked === true && Action === "1") {
            const propsJsonClose = dependentActions[2].propsJson
            if (propsJsonClose === null) {
                NotificationManager.error(`Vui lòng nhập Mã ID Ticket *`);
                return;
            }
            else {
                if (propsJsonClose.IDTicket === "" || propsJsonClose.IDTicket === null || propsJsonClose.IDTicket === undefined) {
                    NotificationManager.error(`Vui lòng nhập Mã ID Ticket *`);
                    return;
                }
                // else if (propsJsonClose.ActionID === "" || propsJsonClose.ActionID === null || propsJsonClose.ActionID === undefined) {
                //     NotificationManager.error(`Vui lòng nhập tên ID từng bước *`);
                //     return;
                // }
                else if (propsJsonClose.UserEmail === "" || propsJsonClose.UserEmail === null || propsJsonClose.UserEmail === undefined) {
                    NotificationManager.error(`Vui lòng nhập email người đóng *`);
                    return;
                }
                else {
                    setOpen(false);
                    NotificationManager.success(`Kích hoạt thành công `);
                }
            }
        }
        else if (dependentActions[4].checked === true && Action === "1") {
            const propsJsonClose = dependentActions[4].propsJson
            //console.log("propsJsonClose", propsJsonClose);
            if (propsJsonClose === null) {
                NotificationManager.error(`Vui lòng nhập Mã ID Ticket *`);
                return;
            }
            else {
                if (propsJsonClose.IDTicket === "" || propsJsonClose.IDTicket === null || propsJsonClose.IDTicket === undefined) {
                    NotificationManager.error(`Vui lòng nhập Mã ID Ticket *`);
                    return;
                }
                // else if (propsJsonClose.ActionID === "" || propsJsonClose.ActionID === null || propsJsonClose.ActionID === undefined) {
                //     NotificationManager.error(`Vui lòng nhập tên ID duyệt *`);
                //     return;
                // }
                else if (propsJsonClose.UserEmail === "" || propsJsonClose.UserEmail === null || propsJsonClose.UserEmail === undefined) {
                    NotificationManager.error(`Vui lòng nhập email người duyệt *`);
                    return;
                }
                else {
                    setOpen(false);
                    NotificationManager.success(`Kích hoạt thành công `);
                }
            }
        }
        else if (Action === "0") {
            let array = [...dependentActions]
            // eslint-disable-next-line
            dependentActions.map((item, index) => {
                array = [...array.slice(0, index),
                {
                    ...array[index],
                    checked: false
                },
                ...array.slice(index + 1)
                ]
            })
            setDependentActions(array);
            setOpen(false);
            NotificationManager.success(`Hủy kích hoạt thành công `);
        }
        else if (Action === "1") {
            setOpen(false);
            NotificationManager.success(`Kích hoạt thành công `);
        }
        else if (Action === "3") {
            setOpen(false);
        }
    };
    const onChangeAction = (value, index, status, actionID) => {
        if (status === "INIT") {
            setDependentActions([
                ...dependentActions.slice(0, index),
                {
                    ...dependentActions[index],
                    checked: value.target.checked
                },
                ...dependentActions.slice(index + 1)
            ]);
        }

        else if (status === "USE") {

            let indexNew = dependentActions.indexOf(dependentActions.find(x => { return x.actionID === actionID }));
            setDependentActions([
                ...dependentActions.slice(0, indexNew),
                {
                    ...dependentActions[indexNew],
                    propsJson: {
                        ...dependentActions[indexNew].propsJson,
                        ...value
                    }
                },
                ...dependentActions.slice(indexNew + 1)
            ]);
        }
    };

    return <>
        <ActionComponent label={label} checked={checked} status={status} type={type} openDialog={handleClickOpen} />
        <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            maxWidth={"md"}
            fullWidth={true}
            disableEnforceFocus={true}
        >
            <DialogContent>
                <div className="row action-config">
                    <span className="col-md-12 action-config-title">Cấu hình thao tác</span>
                    <div className="col-md-12">
                        <div className="row">
                            <div className="col-md-6">
                                <TextField
                                    className="action-config-input"
                                    fullWidth
                                    id="outlined-name"
                                    label="Tên thao tác"
                                    margin="dense"
                                    variant="outlined"
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    value={label}
                                    disabled
                                />
                                <ItsmInput label="Màu nền" className="action-config-input">
                                    <input className="clsColor" type="color" value={backgroundColor} onChange={(e) => setBackgroundColor(e.target.value)} />
                                </ItsmInput>
                            </div>
                            <div className="col-md-6">
                                <TextField
                                    className="action-config-input"
                                    fullWidth
                                    id="outlined-name"
                                    label="Đặt lại Tên thao tác"
                                    margin="dense"
                                    variant="outlined"
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    onChange={(e) => setRename(e.target.value)}
                                    value={rename}
                                />
                                <ItsmInput label="Màu viền" className="action-config-input">
                                    <input className="clsColor" type="color" value={borderColor} onChange={(e) => setBorderColor(e.target.value)} />
                                </ItsmInput>
                            </div>
                        </div>
                    </div>
                    <span className="col-md-12 action-config-title">Thao tác kèm theo</span>
                    <div className="col-md-12">
                        <div>
                            {dependentActions.map((item, index) => {
                                return <ActionComponent key={index} status="INIT" data={typeof item.propsJson === "string" ? JSON.parse(item.propsJson) : item.propsJson} type={item.component} label={item.name} checked={item.checked} onChange={(e, status) => onChangeAction(e, index, status)} />
                            })}
                        </div>
                    </div>
                    <div className="col-md-12 action-config-use">
                        {dependentActions.filter(item => item.checked).map((item, index) => {
                            return <ActionComponent feeds={feeds} key={index} data={typeof item.propsJson === "string" ? JSON.parse(item.propsJson) : item.propsJson} status="USE" type={item.component} label={item.name} checked={item.checked} onChange={(e, status) => onChangeAction(e, index, status, item.actionID)} />
                        })}
                    </div>
                </div>
            </DialogContent>
            <DialogActions className="dialog-actions">
                <Button className="dialog-actions-active"
                    onClick={() => {
                        onChange({ checked: true, dependentActions: dependentActions, propsJson: { rename: rename, backgroundColor: backgroundColor, borderColor: borderColor } });
                        handleClose("1");
                    }} color="primary" autoFocus
                    startIcon={<MdCheck />}
                >
                    Kích hoạt
                </Button>
                <Button className="dialog-actions-deactive"
                    onClick={() => {
                        onChange({ checked: false, dependentActions: dependentActions, propsJson: { rename: rename, backgroundColor: backgroundColor, borderColor: borderColor } });
                        handleClose("0");
                    }} color="primary"
                    startIcon={<MdClose />}>
                    Hủy kích hoạt
                </Button>
                <Button className="dialog-actions-deactive"
                    onClick={() => {
                        handleClose("3");
                    }} color="primary"
                    startIcon={<MdClose />}>
                    Đóng
                </Button>
            </DialogActions>
        </Dialog>
    </>
}